/* eslint-disable */
import parse from 'date-fns/parse';

/**
 * Converts the date into a new date in the timezone specified by the offset
 * @param {string} date The date and time object
 * @param {number} offset The timezone offset in minutes
 * @returns {Date} The date and time in the specified timezone.
 */
const convertWithTimezone = (date, offset) => {
  return parse(date + -offset * 60000);
};

export default convertWithTimezone;
